import { useState } from 'react'

import { useAppSelector } from 'app-redux/hooks'
import { useApplyBodyClass } from 'hooks/useScrollEffects'
import { useCanEditDeck } from 'app-redux/deck/selectors'

import Icon from 'components/elements/Icon'

import styles from './emptyDeckLanding.module.scss'

const NewDeckView = () => {
  const canEditDeck = useCanEditDeck()

  const sandbox = useAppSelector(state => !state.deck.id)
  const intentionallySkippedCardData = useAppSelector(state => state.deck.intentionallySkippedCardData)
  const hasCards = useAppSelector(state => !!Object.keys(state.deck.cardMap).length)

  // Once the new deck view is closed, this prevents it from ever coming back (without a reload)
  const [open, setOpen] = useState(!hasCards && !intentionallySkippedCardData)

  useApplyBodyClass(open && !hasCards, 'empty-deck-overlay')

  if (hasCards || intentionallySkippedCardData || !open) return null
  if (open && !canEditDeck) return <div className={styles.empty}>This deck is empty</div>

  const emptyDeckMessage = <p>You're viewing an empty deck</p>
  const sandboxMessage = (
    <p>
      Keep in mind that <span className={styles.orange}>you're in the sandbox</span>. Anything done here won't save
      unless you have an account and create a deck.
    </p>
  )

  return (
    <div className={styles.container}>
      <div className={styles.desktopMessage}>
        <button onClick={() => setOpen(false)}>
          <Icon name="close" />
        </button>

        {emptyDeckMessage}

        {canEditDeck && <p>Use the tools above to add cards, or import cards from your clipboard or a precon</p>}

        {sandbox && sandboxMessage}
      </div>

      <div className={styles.mobileMessage}>
        {emptyDeckMessage}

        {canEditDeck && <p>Use the tools below to add cards, or import cards from your clipboard or a precon</p>}

        {sandbox && sandboxMessage}
      </div>

      {canEditDeck && (
        <div className={styles.mobileInstructions}>
          <div className={styles.fauxGrid}>
            <div className={styles.helper}>
              Add cards with these
              <Icon className={styles.bounce} name="arrow down" />
            </div>

            <div />
            <div />

            <div className={styles.helper}>
              Import cards
              <Icon className={styles.bounce} name="arrow down" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default NewDeckView
